import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateHomeSection } from "../../api/apiHomeSections";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useUpdateHomeSection = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const { mutate: updateSectionMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateHomeSection(id, data),
        onSuccess: (res) => {
            toast.success(res.message);
            queryClient.invalidateQueries(["home-sections"]);
            queryClient.invalidateQueries(["home-section"]);
        },
        onError: (error) => {
            console.error("Error updating home section:", error);
            toast.error(error.response?.data?.message || t("Error updating home section"));
        },
    });

    return { updateSectionMutate, isUpdating };
};
